import React, { FunctionComponent } from 'react';
//import { getBaseSearchURL} from "../../utils/searchHelpers";


export interface IInformationMessageBoxProps {
    isDesktop: boolean;
    currentPage: string;
    informationMessage?: string;
}



export const InformationMessageBox: FunctionComponent<IInformationMessageBoxProps> = ({isDesktop, currentPage, informationMessage})  => {
    if (!informationMessage || informationMessage.trim().length === 0) {
        return null;
    }
    return (
        <div className="alert-placeholder">
            <div className="alert-block">
                <span className="alert-global"></span>
                <span className={isDesktop ? "infoMessage" : "infoMessageMobile"}>{informationMessage}</span>
            </div>
        </div>
    );
}

